import React, { useEffect, useState, useRef } from 'react';
import * as _ from 'lodash';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFSelect from '../../controls/tempRHFControls/RHFSelect';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import DialogList from 'src/dialogs';
import useFetch from 'use-http';
import { BiAddToQueue } from 'react-icons/bi';
import ProspectDetails from 'src/models/projectSettings/TsdiProspect';
import { ODataOptions, ODataFilter, ODataFilterOperators, ODataOrderByDirection, /*ODataOrderByDirection*/ } from 'src/util/ODataBuilder';
import CollapsibleSection from 'src/components/common/CollapsibleSection';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import { FaFileCsv, FaPlay } from 'react-icons/fa'; // "Play" icon for execution
import TsdiClientInfo from 'src/models/AP/ClientInfo';
import TsdiSubcode from 'src/models/AP/Subcode';
import AltSubCode from 'src/models/AP/AltSubcode';
import { SiMicrosoftexcel } from 'react-icons/si';
import { FaFileExcel, FaBolt, FaCogs } from 'react-icons/fa';
import { FiEdit } from 'react-icons/fi';
import { FaHandPaper, FaCheckCircle, FaLock } from 'react-icons/fa';
import { MdCancel } from 'react-icons/md';
// import TsdiInvoice from 'src/models/Invoice';
import { FaPenSquare } from 'react-icons/fa';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import TsdiInvoiceGroup from 'src/components/project-billing/models/InvoiceGroup';
import TsdiInvoiceGroupRequest from 'src/components/project-billing/models/InvoiceGroupRequest';
import InvoiceGroupSubcode from 'src/models/AP/InvoiceGroupSubcode';
import LoadingSpinner from 'src/components/common/LoadingSpinner';

interface IInvoiceGroupingDialogProps {
    dialogName: string;
    subCode?: TsdiSubcode;
    subCodes?: Array<InvoiceGroupSubcode>;
    project: ProspectDetails;
    client: TsdiClientInfo;
    handleReport?: (category: string, subcategory: string) => void;
    handleClosureRequest?: (groupNumber: number, cancelRequest: boolean, close: boolean) => void;
    handleClosure?: (group: number, cancelRequest: boolean) => void;
    hideDialog: () => void;
    showDialog: (dialogName: DialogList) => void;
    showAddSubcodeDialog?: () => void;
    showEditInvoiceGroupDialog?: () => void;
    setAddingAltSubcode?: (addingAltSubcode: boolean) => void;
    setFindingAltSubcode?: (findingAltSubcode: boolean) => void;
    setShowBillingSettings?: (showBillingSettings: boolean) => void;
    setInvoiceGroup?: (group: TsdiInvoiceGroup) => void;
    setInvoiceGroups?: (groups: Array<TsdiInvoiceGroup>) => void;
    setShowInvoiceGroups?: (show: boolean) => void;
    generateInvoiceGroupCoverLetter?: () => void;
    setCreatingInvoiceGroup?: (sectionIds: Array<InvoiceGroupSubcode>) => void;
    setAddingSections?: (adding: boolean) => void;
    setInvoiceGroupRequests?: (igRequests: Array<TsdiInvoiceGroupRequest>) => void;
    handleViewDocumentMaintenance?: (invoiceNumber: number, invoiceGrouNumber: number) => void;
    getSupplierLinkCsv?: (invoiceGroupNumber: string) => Promise<Blob> | null;
    confirmDocumentGeneration?: () => void;
}

const InvoiceGroupingDialog = (props: IInvoiceGroupingDialogProps) => {
    // const { register, reset, getValues, setValue } = useForm();
    // const dispatch = useDispatch();
    const { register: registerInvoiceGroups, /*reset: resetState*/ } = useForm();
    const { register: registerSubcodes, setValue: setSubcodesValue, reset: resetSubcodes, getValues: getSubcodesValues } = useForm();
    const { reset: resetAltSubcodes, getValues: getAltSubCodesValues } = useForm();
    const { register: registerClientProspect, getValues: getClientProspectValues, reset: resetClientProspectState } = useForm();
    const { /*register: registerAggregateTotal,*/ reset: resetAggregateTotal, setValue: setAggregateTotalValue } = useForm();
    const { get, /*post, put, */ response } = useFetch();
    const [altSubcodeSearchOptions, setAltSubcodeSearchOptions] = useState<ODataOptions>(undefined);
    const [invoiceGroupSearchOptions, setInvoiceGroupSearchOptions] = useState<ODataOptions>(new ODataOptions());
    const [altSubcodeSearchTerm, setAltSubcodeSearchTerm] = useState<string>('');
    const [altSubcodes, setAltSubcodes] = useState<Array<TsdiSubcode>>(undefined);
    const [invoiceGroups, setInvoiceGroups] = useState<Array<TsdiInvoiceGroup>>(undefined);
    const [invoiceGroupRequests, setInvoiceGroupRequests] = useState<Array<TsdiInvoiceGroupRequest>>(undefined);
    const [invoiceGroupInvoices, setInvoiceGroupInvoices] = useState<Array<TsdiInvoiceGroup>>(undefined);
    const [invoiceGroup, setInvoiceGroup] = useState<Array<TsdiInvoiceGroup>>(undefined);
    // const [invoices, setInvoices] = useState<Array<TsdiInvoice>>(undefined);
    const [selectedInvoiceGroupIndex, setSelectedInvoiceGroupIndex] = useState<number>(undefined);
    const [selectedInvoiceIndex, setSelectedInvoiceIndex] = useState<number>(undefined);
    const [selectedSubcodeIndex, setSelectedSubcodeIndex] = useState<number>(undefined);
    const [creatingGroup, setCreatingGroup] = useState<object>(undefined);
    const [loadingInvoices, setLoadingInvoices] = useState<boolean>(false);
    const [totalMismatch, setTotalMismatch] = useState<boolean>(true);
    const totalElementRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (Array.isArray(invoiceGroupInvoices)) {
            setLoadingInvoices(false);
            if (Array.isArray(invoiceGroupInvoices) && invoiceGroupInvoices.length > 0) {
                const grandTotal = invoiceGroupInvoices.reduce((sum, item) => {
                    const value = Number(item?.total);
                    return Number.isFinite(value) ? sum + value : sum;
                }, 0);
                if (Array.isArray(invoiceGroups) && invoiceGroups.length > selectedInvoiceGroupIndex) {
                    const groupTotal = Number(invoiceGroups[selectedInvoiceGroupIndex]?.groupTotal);
                    if (!isNaN(grandTotal) && totalElementRef?.current) {
                        if (!isNaN((grandTotal))) {
                            const roundedGrandTotal =  Math.round(grandTotal * 100) / 100;
                            totalElementRef.current.value = roundedGrandTotal.toString();
                            setTotalMismatch(roundedGrandTotal !== groupTotal);
                        }
                    }
                } else {
                    setTotalMismatch(true);
                }
            }
        }
    }, [invoiceGroupInvoices]);

    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        if (Array.isArray(invoiceGroupRequests) && typeof props?.setInvoiceGroupRequests === 'function') {
            props.setInvoiceGroupRequests(invoiceGroupRequests);
        }
    }, [invoiceGroupRequests]);

    useEffect(() => {
        if (props?.client && props?.project) {
            resetClientProspectState({clientNumber: props?.client?.clientNumber, projectNumber: props?.project.number});
            resetInvoiceGroupSearchOptions();
        }
    }, [props?.client, props?.project]);

    useEffect(() => {
        if (selectedInvoiceGroupIndex !== undefined && Array.isArray(invoiceGroups) && invoiceGroups.length > selectedInvoiceGroupIndex) {
            setTotalMismatch(true);
            const selected = invoiceGroups[selectedInvoiceGroupIndex];
            if (typeof props?.setInvoiceGroup === 'function') {
                props.setInvoiceGroup(selected);
            }
            setAggregateTotalValue('aggregateTotal', formatForCurrency(selected?.groupTotal?.toString()));
            const igNumber = selected.groupNumber;
            const invoiceGroupInvoicesSearchOptions = _.cloneDeep(invoiceGroupSearchOptions);
            invoiceGroupInvoicesSearchOptions.clearFilters();
            invoiceGroupInvoicesSearchOptions.addFilter(new ODataFilter('igi.[ir_no]', ODataFilterOperators.Equals, igNumber));
            getInvoiceGroupInvoices(invoiceGroupInvoicesSearchOptions.toString());
        }
    }, [selectedInvoiceGroupIndex]);

    useEffect(() => {
        if (Array.isArray(props?.subCodes)) {
            resetSubcodes({
                subcodes: props.subCodes.map(() => ({
                    selected: false
                }))
            });
        }
    }, [props?.subCodes]);

    useEffect(() => {
        if (creatingGroup) {
            props?.showEditInvoiceGroupDialog();
        }
    }, [creatingGroup]);

    useEffect(() => {
        if (!!altSubcodes) {
            populateAltSubcodeForm(altSubcodes[0]);
        }
    }, [altSubcodes]);

    useEffect(() => {
        if (!!altSubcodeSearchOptions) {
            getAltSubCodes();
        }
    }, [altSubcodeSearchOptions]);

    useEffect(() => {
        if (invoiceGroupSearchOptions && invoiceGroupSearchOptions?.hasFilters()) {
            setInvoiceGroups([]);
            getInvoiceGroups();
        }
    }, [invoiceGroupSearchOptions]);

    useEffect(() => {
        if (Array.isArray(invoiceGroups) && invoiceGroups.length > 0) {
            if (typeof props?.setInvoiceGroups === 'function') {
                props?.setInvoiceGroups(invoiceGroups);
            }
            setInvoiceGroup(getInvoiceGroup(invoiceGroups));
        }
    }, [invoiceGroups]);

    useEffect(() => {
        if (Array.isArray(invoiceGroup) && invoiceGroup.length > 0 && selectedInvoiceGroupIndex === undefined) {
            setAggregateTotalValue('aggregateTotal', formatForCurrency(invoiceGroup[0]?.groupTotal?.toString()));
            if (typeof props?.setInvoiceGroup === 'function') {
                props?.setInvoiceGroup(invoiceGroup[0]);
            }
        }
    }, [invoiceGroup]);

    useEffect(() => {
        if ((!!altSubcodeSearchTerm || altSubcodeSearchTerm === '') && !!altSubcodeSearchOptions) {
            resetAltSubcodeSearchOptions();
        }
    }, [altSubcodeSearchTerm]);

    const onCreate = () => {
        resetInvoiceGroupSearchOptions();
        resetAggregateTotal({ aggregateTotal: '0.0' });
    };

    const formatForCurrency = (value: string): string => {
        const num = Number(value);

        if (isNaN(num)) {
            return value;
        }

        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(num);
    };

    const getInvoiceGroups = async () => {
        const queryString = invoiceGroupSearchOptions?.toString();
        let result = await get(`/v1.0/AccountsPayable/invoice/groups${queryString}`);

        if (response.ok && result?.length > 0) {
            setInvoiceGroups(result);
        } else {
            setInvoiceGroups([]);
            console.log('Unable to get Invoice Group Data!!!');
        }
    };

    const handleEditCoverLetter = (groupNumber: number) => {
        let newInvoiceGroupSearchOptions = _.cloneDeep(invoiceGroupSearchOptions);
        newInvoiceGroupSearchOptions.clearFilters();
        newInvoiceGroupSearchOptions.addFilter(new ODataFilter('[ir_no]', ODataFilterOperators.Equals, groupNumber));
        getInvoiceGroupRequests(newInvoiceGroupSearchOptions.toString());
    };

    const getInvoiceGroupRequests = async (queryString: string) => {
        let result = await get(`/v1.0/AccountsPayable/invoice/group/requests${queryString}`);

        if (response.ok && result?.length > 0) {
            setInvoiceGroupRequests(result);
        } else {
            setInvoiceGroupRequests([]);
            console.log('Unable to get Invoice Group Request Data!!!');
        }
    };

    const getInvoiceGroupInvoices = async (queryString: string) => {
        setLoadingInvoices(true);
        let result = await get(`/v1.0/AccountsPayable/invoice/group/invoices${queryString}`);

        if (response.ok && result?.length > 0) {
            setInvoiceGroupInvoices(result);
        } else {
            setInvoiceGroupInvoices([]);
            console.log('Unable to get Invoice Group Invoice Data!!!');
        }
    };

    const handleSelectAll = (checked: boolean) => {
        props.subCodes?.forEach((subCode, index) => {
            if (!subCode.groupNumber || checked === false) {
                setSubcodesValue(`subcodes[${index}].selected`, checked, { shouldDirty: true });
            }
        });
    };

    const getInvoiceGroup = (
        rows: TsdiInvoiceGroup[]
      ): TsdiInvoiceGroup[] => {
        const map = new Map<number, TsdiInvoiceGroup>();

        rows.forEach(row => {
            if (row?.groupNumber && !map.has(row.groupNumber)) {
                map.set(row.groupNumber, row);
            }
        });

        return Array.from(map.values());
    };

/*     const getInvoices = () => {
        let localInvoices = new Array<TsdiInvoice>();
        let invoice = new TsdiInvoice();
        invoice.id = 1;
        invoice.accountsReceivable = 'Y';
        invoice.date = new Date();
        invoice.description = 'For Ralph Currington';
        invoice.districtTownship = 'Lullapaloosa';
        invoice.igAccount = 'For the love of RC';
        invoice.number = 1;
        invoice.total = 1000;
        invoice.tract = '100 Acres';
        invoice.voucher = 'N';
        invoice.section = 60;
        localInvoices.push(invoice);
        setInvoices(localInvoices);
    }; */

    const resetInvoiceGroupSearchOptions = () => {
        const clientNumber = props?.client?.clientNumber;
        const projectNumber = props?.project?.number;
        const searchValues = getClientProspectValues();
        const groupNumber = getClientProspectValues('groupNumber');
        if (clientNumber) {
            let newInvoiceGroupSearchOptions = _.cloneDeep(invoiceGroupSearchOptions);
            newInvoiceGroupSearchOptions.setIsNextpage(true);
            newInvoiceGroupSearchOptions.clearFilters();
            newInvoiceGroupSearchOptions.addPaging(1, 100);
            newInvoiceGroupSearchOptions.addSkipTop(0, 100);
            newInvoiceGroupSearchOptions.addFilter(new ODataFilter('p.[cl_no]', ODataFilterOperators.Equals, clientNumber));

            if (projectNumber) {
                newInvoiceGroupSearchOptions.addFilter(new ODataFilter('p.[pr_no]', ODataFilterOperators.Equals, projectNumber));
            }

            if (searchValues?.groupStatus && searchValues?.groupStatus !== '1') {
                switch (searchValues.groupStatus) {
                    case '2' :
                    newInvoiceGroupSearchOptions.addFilter(new ODataFilter('ir.IR_DATE', ODataFilterOperators.Equals, 'NULL'));
                    break;
                    case '3' :
                    newInvoiceGroupSearchOptions.addFilter(new ODataFilter('ir.REQUEST_DATE', ODataFilterOperators.NotEquals, 'NULL'));
                    newInvoiceGroupSearchOptions.addFilter(new ODataFilter('ir.IR_DATE', ODataFilterOperators.Equals, 'NULL'));
                    break;
                    case '4' :
                    newInvoiceGroupSearchOptions.addFilter(new ODataFilter('ir.IR_DATE', ODataFilterOperators.NotEquals, 'NULL'));
                    break;
                    default :
                    break;
                }
            }
            if (groupNumber) {
                newInvoiceGroupSearchOptions.addFilter(new ODataFilter('ir.[IR_NO]', ODataFilterOperators.Equals, groupNumber));
            }
            if (searchValues?.billingOffice && searchValues?.billingOffice !== 'ALL') {
                newInvoiceGroupSearchOptions.addFilter(new ODataFilter('p.[OFFICE]', ODataFilterOperators.Equals, searchValues?.billingOffice));
            }
            if (searchValues?.sortBy && searchValues?.sortBy !== '*') {
                const direction = searchValues?.sortDirection === '1' ? ODataOrderByDirection.Descending : ODataOrderByDirection.Ascending;
                switch (searchValues.sortBy) {
                    case '1' :
                        newInvoiceGroupSearchOptions.addOrderBy('ir.[IR_NO]', direction);
                        break;
                    case '2' :
                        newInvoiceGroupSearchOptions.addOrderBy('ir.[REQUEST_DATE]', direction);
                        break;
                    case '3' :
                        newInvoiceGroupSearchOptions.addOrderBy('p.[CL_NO]', direction);
                        break;
                    case '4' :
                        newInvoiceGroupSearchOptions.addOrderBy('[IG_VALUE]', direction);
                        break;
                    case '5' :
                        newInvoiceGroupSearchOptions.addOrderBy('[CREATE_USER]', direction);
                        break;
                    case '6' :
                        newInvoiceGroupSearchOptions.addOrderBy('p.[OFFICE]', direction);
                        break;
                    case '7' :
                        newInvoiceGroupSearchOptions.addOrderBy('ir.[IR_DATE]', direction);
                        break;
                    case '8' :
                        newInvoiceGroupSearchOptions.addOrderBy('ir.[IR_USER]', direction);
                        break;
                    default :
                        newInvoiceGroupSearchOptions.addOrderBy('ir.[IR_NO]', ODataOrderByDirection.Descending);
                        break;
                }
            } else {
                newInvoiceGroupSearchOptions.addOrderBy('ir.[IR_NO]', ODataOrderByDirection.Descending);
            }
            setInvoiceGroupSearchOptions(newInvoiceGroupSearchOptions);
        }
    };

    const resetAltSubcodeSearchOptions = () => {
        let newProjectSearchOptions = _.cloneDeep(altSubcodeSearchOptions);
        newProjectSearchOptions.setIsNextpage(true);
        newProjectSearchOptions.clearFilters();
        newProjectSearchOptions.addPaging(1, 1000);
        const projectId = !!props?.project?.id ? props?.project?.id : 0;
        if (!projectId) {
            return;
        }
        newProjectSearchOptions.addFilter(new ODataFilter('s.[PR_ID]', ODataFilterOperators.Equals, projectId));
        if (typeof altSubcodeSearchTerm === 'string') {
            const fieldValues = altSubcodeSearchTerm.split(',');
            if (fieldValues[0] !== undefined && !isNaN(Number(fieldValues[0])) && fieldValues[0] !== ' ' && fieldValues[0]?.length > 0) {
                newProjectSearchOptions.addFilter(new ODataFilter('u.[UN_NO]', ODataFilterOperators.Equals, !!altSubcodeSearchTerm ? fieldValues[0] : ''));
            }
            if (fieldValues[1] !== undefined && fieldValues[1]?.length > 0 && fieldValues[1] !== ' ') {
                newProjectSearchOptions.addFilter(new ODataFilter('u.[UN_NAME]', ODataFilterOperators.Contains, !!altSubcodeSearchTerm ? fieldValues[1] : ''));
            }
            if (fieldValues[2] !== undefined && fieldValues[2]?.length > 0 && fieldValues[2] !== ' ') {
                newProjectSearchOptions.addFilter(new ODataFilter('s.[SECTION_TYPE]', ODataFilterOperators.Contains, !!altSubcodeSearchTerm ? fieldValues[2] : ''));
            }
        }
        setAltSubcodeSearchOptions(newProjectSearchOptions);
    };

    const onAltSubcodeSearchChanged = (searchContent: string) => {
        search();
    };

    const search = _.debounce(() => {
        const formData = getAltSubCodesValues();
        const projectId = !!props?.project?.id ? props?.project?.id : 0;
        if (!projectId) {
            return;
        }
        let searchString =  (!!formData?.searchSubcodeNumber ? formData.searchSubcodeNumber : ' ');
        searchString += ',' +  (!!formData?.searchSubcodeName ? formData.searchSubcodeName : ' ');
        searchString += ',' +  (!!formData?.searchSubcodeType ? formData.searchSubcodeType : ' ');
        setAltSubcodeSearchTerm(searchString);
    }, 700);

    const onSubmit = () => {
        console.log('OK Clicked');
        let data = getAltSubCodesValues();

        props.handleReport(getAltSubCodesValues('category'), getAltSubCodesValues('subcategory'));
        props.hideDialog();

        console.log(data);
    };

    const displayTitle = () => {
        const title = 'Sort Options';

        return title;
    };

    const displaySubTitle = () => {
        const title = 'Invoice Groups';

        return title;
    };

    const displaySectionsSubtitle = () => {
        const title = 'Subcodes';

        return title;
    };

    const getAltSubCodes = async () => {
        const queryString = altSubcodeSearchOptions?.toString();
        const subCodeId = props?.subCode?.id;
        if (subCodeId > 0) {
            let result = await get(`/v1.0/ClientProjectMaintenance/subcode/${subCodeId}/altsubcodes${queryString !== undefined ? queryString : ''}`);

            if (response.ok) {
                setAltSubcodes(result);
            } else {
                setAltSubcodes([]);
                console.log('Unable to get subcode data!');
            }
        }
    };

    const onCancel = () => {
        props.hideDialog();        
    };

    const populateAltSubcodeForm = (payload: AltSubCode) => {
        resetAltSubcodes(payload);
    };

    const handleAddSections = (index: number) => {
        const selectedSubcodes = getSubcodesValues()?.subcodes;
        const subcodeList = selectedSubcodes
            ?.filter((subCode: InvoiceGroupSubcode) => subCode?.selected && !subCode?.groupNumber);

        if (Array.isArray(subcodeList) && subcodeList.length > 0 && Array.isArray(invoiceGroups) && invoiceGroups.length > index) {
            const groupNumber = invoiceGroups[index].groupNumber;
            const groupId = invoiceGroups[index].groupId;
            subcodeList[0].groupNumber = groupNumber;
            subcodeList[0].groupId = groupId;
            props.setAddingSections(true);
            props.setCreatingInvoiceGroup(subcodeList);
        } else {
            alert('You must select at least 1 section.');
        }
    };

    const handleCreateInvoiceGroup = () => {
        const selectedSubcodes = getSubcodesValues()?.subcodes;
        const subcodeList = selectedSubcodes
            ?.filter((subCode: InvoiceGroupSubcode) => subCode.selected && !subCode.groupNumber);

        if (Array.isArray(subcodeList) && subcodeList.length > 0) {
            if (props?.setCreatingInvoiceGroup && typeof props.setCreatingInvoiceGroup === 'function') {
                props.setCreatingInvoiceGroup(subcodeList);
                setCreatingGroup(new Object());
            }
        } else {
            alert('You must select at least 1 section\r\nthat does not belong to an existing group.');
        }
    };

    const handleClosureOrCancellationRequest = (igNumber: number, isCancellation: boolean, close: boolean) => {
        if (props?.handleClosureRequest) {
            props.handleClosureRequest(igNumber, isCancellation, close);
        }
    };

    const shouldDisableClose = (requestDate: Date, closeDate: Date) => {
        if ((requestDate !== null && closeDate !== null) || (requestDate === null && closeDate === null)) {
            return true;
        } else {
            return false;
        }
    };

    const handleViewDocumentMaintenance = () => {
        if (Array.isArray(invoiceGroups) && invoiceGroups.length > selectedInvoiceGroupIndex) {
            const igNumber = invoiceGroups[selectedInvoiceGroupIndex]?.groupNumber;
            if (props?.handleViewDocumentMaintenance && igNumber) {
                props.handleViewDocumentMaintenance(null, igNumber);
            }
        }
    };

    const handleGetSupplierLinkCsv = async (groupNumber: string) => {
        if (props?.getSupplierLinkCsv && groupNumber) {
            await props.getSupplierLinkCsv(groupNumber);
        }
    };

    const handleFilterInvoiceGroups = () => {
        resetInvoiceGroupSearchOptions();
    };

/*     const shouldDisableIfClosed = (requestDate: Date, closeDate: Date) => {
        if (requestDate !== null && closeDate !== null) {
            return true;
        } else {
            return false;
        }
    }; */

    const displaySubcodeSettingButtons = () => {
        return (
            <>
                <div style={{display: 'flex', justifyContent: 'flex-start'}}>
                    <RHFInputBox
                        onChange={(event) => onAltSubcodeSearchChanged(event.currentTarget.value)}
                        name={'clientNumberDisplay'}
                        defaultVal={props?.client?.clientNumber?.toString()}
                        style={{ width: '30%' }}
                        bodyStyle={{width: '60%' }}
                        readOnly={true}
                    />
                    <RHFInputBox
                        name={'projectNumberDisplay'}
                        defaultVal={props?.project?.number?.toString()}
                        style={{ width: '30%' }}
                        bodyStyle={{width: '60%' }}
                        readOnly={true}
                    />
                    {props?.subCode &&
                        <RHFInputBox
                            name={'subcodeNumber'}
                            defaultVal={props?.subCode?.number?.toString()}
                            style={{ width: '30%' }}
                            bodyStyle={{width: '60%' }}
                            register={registerClientProspect}
                            readOnly={true}
                        />}
                </div>
            </>
        );
    };

    const displaySections = () => {
        return  <table className={'project-billing'} style={{textAlign: 'left'}}>
                    <thead className={'project-billing'}>
                        <tr className={'project-billing'}>
                            <th
                                colSpan={12}
                                style={{
                                    textAlign: 'left',
                                    padding: 0,
                                    margin: 0,
                                    fontWeight: 'normal',
                                    background: 'transparent'
                                }}
                            >
                                <RHFCheckbox
                                    defaultVal={'false'}
                                    onChange={(e) => handleSelectAll(e.currentTarget.checked)}
                                    name="selectAll"
                                    label="Select / Deselect All"
                                    bodyStyle={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        margin: 0,
                                        padding: 0
                                    }}
                                    labelStyle={{
                                        margin: 0,
                                        padding: 0,
                                        whiteSpace: 'nowrap'
                                    }}
                                />
                            </th>
                        </tr>
                        <tr>
                            <th style={{ width: '2%' }}/>
                            <th style={{ width: '3%' }}>#</th>
                            <th style={{ width: '5%' }}>Name</th>
                            <th style={{ width: '5%' }}>District/Township</th>
                            <th style={{ width: '5%' }}>Tract</th>
                            <th style={{ width: '5%' }}>Municipality</th>
                            <th style={{ width: '5%' }}>Prospect Group #</th>
                            <th style={{ width: '5%' }}>Invoice Group #</th>
                            <th style={{ width: '5%' }}>Client Acct Code</th>
                            <th style={{ width: '5%' }}>Open Invoices</th>
                            <th style={{ width: '5%' }}>Days Billed</th>
                            <th style={{ width: '5%' }}>Last T&E Entry Date</th>
                        </tr>
                    </thead>
                    <tbody className={'project-billing'} style={{width: '100%', maxHeight: '30vh', overflowY: 'scroll'}}>
                    {props?.subCodes && props?.subCodes?.length > 0 && props?.subCodes?.map(
                        (sc: InvoiceGroupSubcode, index: number) => {
                            return (
                                <tr
                                    key={index}
                                    tabIndex={0}
                                    id={'billingApprovalRow' + index}
                                    className="table-item-hover"
                                    style={{overflow: 'hidden', textAlign: 'center' }}
                                    onClick={() => setSelectedSubcodeIndex(index)}
                                >
                                    <td style={{ width: '2%' }}>
                                        <RHFCheckbox
                                            register={registerSubcodes}
                                            name={`subcodes[${index}].selected`}
                                            defaultVal={'false'}
                                            disabled={sc?.groupNumber !== null}
                                            onChange={() => {
                                                if (sc?.groupNumber !== null) {
                                                alert('This subcode is already assigned to a group and cannot be selected.');
                                                }
                                            }}
                                        />
                                    </td>
                                    <td style={{ width: '3%' }}>
                                        <RHFInputBox
                                            name={`subcodes[${index}].sectionNumber`}
                                            readOnly={true}
                                            type="text"
                                            defaultVal={sc?.sectionNumber?.toString()}
                                            register={registerSubcodes}
                                            style={selectedSubcodeIndex !== undefined && selectedSubcodeIndex !== null && selectedSubcodeIndex === index ?
                                                {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '5%' }}>
                                        <RHFInputBox
                                            name={`subcodes[${index}].description`}
                                            readOnly={true}
                                            type="text"
                                            defaultVal={sc?.name}
                                            register={registerSubcodes}
                                            style={selectedSubcodeIndex !== undefined && selectedSubcodeIndex !== null && selectedSubcodeIndex === index ?
                                                {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '5%' }}>
                                        <RHFInputBox
                                            name={`subcodes[${index}].district`}
                                            readOnly={true}
                                            type="text"
                                            defaultVal={sc?.district}
                                            register={registerSubcodes}
                                            style={selectedSubcodeIndex !== undefined && selectedSubcodeIndex !== null && selectedSubcodeIndex === index ?
                                                {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '5%' }}>
                                        <RHFInputBox
                                            name={`subcodes[${index}].tract`}
                                            readOnly={true}
                                            type="text"
                                            defaultVal={''}
                                            register={registerSubcodes}
                                            style={selectedSubcodeIndex !== undefined && selectedSubcodeIndex !== null && selectedSubcodeIndex === index ?
                                                {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '5%' }}>
                                        <RHFInputBox
                                            name={`subcodes[${index}].municipality`}
                                            readOnly={true}
                                            type="text"
                                            defaultVal={sc?.municipality}
                                            register={registerSubcodes}
                                            style={selectedSubcodeIndex !== undefined && selectedSubcodeIndex !== null && selectedSubcodeIndex === index ?
                                                {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '5%' }}>
                                        <RHFInputBox
                                            name={`subcodes[${index}].prospectGroupNumber`}
                                            readOnly={true}
                                            type="text"
                                            defaultVal={sc?.prospectGroupNumber ? sc?.prospectGroupNumber?.toString() : null}
                                            register={registerSubcodes}
                                            style={selectedSubcodeIndex !== undefined && selectedSubcodeIndex !== null && selectedSubcodeIndex === index ?
                                                {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '5%' }}>
                                        <RHFInputBox
                                            name={`subcodes[${index}].groupNumber`}
                                            readOnly={true}
                                            type="text"
                                            defaultVal={sc?.groupNumber?.toString()}
                                            register={registerSubcodes}
                                            style={selectedSubcodeIndex !== undefined && selectedSubcodeIndex !== null && selectedSubcodeIndex === index ?
                                                {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '5%' }}>
                                        <RHFInputBox
                                            name={`subcodes[${index}].clientAccountCode`}
                                            readOnly={true}
                                            type="text"
                                            defaultVal={sc?.clientAccountCode}
                                            register={registerSubcodes}
                                            style={selectedSubcodeIndex !== undefined && selectedSubcodeIndex !== null && selectedSubcodeIndex === index ?
                                                {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '5%' }}>
                                        <RHFInputBox
                                            name={`subcodes[${index}].unclosedInvoices`}
                                            readOnly={true}
                                            type="text"
                                            defaultVal={sc?.unclosedInvoices?.toString()}
                                            register={registerSubcodes}
                                            style={selectedSubcodeIndex !== undefined && selectedSubcodeIndex !== null && selectedSubcodeIndex === index ?
                                                {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '5%' }}>
                                        <RHFInputBox
                                            name={`subcodes[${index}].daysBilled`}
                                            readOnly={true}
                                            type="text"
                                            defaultVal={sc?.daysBilled?.toString()}
                                            register={registerSubcodes}
                                            style={selectedSubcodeIndex !== undefined && selectedSubcodeIndex !== null && selectedSubcodeIndex === index ?
                                                {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '5%' }}>
                                        <RHFInputBox
                                            name={`subcodes[${index}].latestTimeEntry`}
                                            readOnly={true}
                                            type="text"
                                            defaultVal={(new Date(sc?.latestTimeEntry)).toLocaleDateString()}
                                            register={registerSubcodes}
                                            style={selectedSubcodeIndex !== undefined && selectedSubcodeIndex !== null && selectedSubcodeIndex === index ?
                                                {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                        <input
                                            ref={registerSubcodes}
                                            name={`subcodes[${index}].sectionId`}
                                            defaultValue={sc?.sectionId?.toString()}
                                            type={'hidden'}
                                            style={{width: '0px'}}
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>;
    };

    const displayInvoiceGroups = () => {
        return  <table className={'project-billing'} style={{textAlign: 'left'}}>
                    <thead className={'project-billing'}>
                        <tr className={'project-billing'}>
                            <th style={{ width: '3.5%' }}>Group</th>
                            <th style={{ width: '4.5%' }}>Created</th>
                            <th style={{ width: '6%' }}>Created by</th>
                            <th style={{ width: '2.5%' }}>CL#</th>
                            <th style={{ width: '4%' }}>PR#</th>
                            <th style={{ width: '5.5%' }}>IG Acct</th>
                            <th style={{ width: '3%' }}>Total</th>
                            <th title={'Office'} style={{ width: '2%' }}>Office</th>
                            <th style={{ width: '2.5%' }}>Cnt</th>
                            <th title={'Sections'} style={{ width: '3%' }}>Secs</th>
                            <th style={{ width: '5%' }}>Request Date</th>
                            <th style={{ width: '5%' }}>Close Date</th>
                            <th style={{ width: '4.5%' }}>Closed By</th>
                            <th style={{ width: '3%' }}>Freq</th>
                            <th style={{ width: '14%' }}/>
                        </tr>
                    </thead>
                    <tbody className={'project-billing'} style={{width: '100%', maxHeight: '32vh', overflowY: 'scroll'}}>
                    {invoiceGroups && invoiceGroups?.length > 0 && invoiceGroups?.map(
                        (ig: TsdiInvoiceGroup, index: number) => {
                        const elementStyle = (selectedInvoiceGroupIndex || selectedInvoiceGroupIndex === 0) && selectedInvoiceGroupIndex === index ?
                        {backgroundColor: '#FFFF77', width: '100%', fontSize: '12px'} : {fontSize: '12px', width: '100%'};
                        const isSelected = index === selectedInvoiceGroupIndex;

                        const totalElementStyle = {
                            width: '100%',
                            fontSize: '12px',
                            backgroundColor: isSelected
                            ? ig?.groupTotal == null             // covers null or undefined
                                ? '#FFFF77'                        // yellow
                                : totalMismatch
                                ? '#CC3333'             // red
                                : '#7CFC00'                      // green
                            : ''                           // gray for non-selected
                        };
                        return (
                                <tr
                                    key={index}
                                    tabIndex={0}
                                    id={'billingApprovalRow' + index}
                                    className="project-billing table-item-hover"
                                    style={{overflow: 'hidden', textAlign: 'center' }}
                                    onClick={() => setSelectedInvoiceGroupIndex(index)}
                                >
                                    <td style={{ width: '3%' }}>
                                        <RHFInputBox
                                            name={`invoiceGroups[${index}].number`}
                                            readOnly={true}
                                            type="text"
                                            defaultVal={ig?.groupNumber?.toString()}
                                            register={registerInvoiceGroups}
                                            style={elementStyle}
                                            bodyStyle={{width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '6%' }}>
                                        <RHFInputBox
                                            name={`invoiceGroups[${index}].creationDate`}
                                            readOnly={true}
                                            type="text"
                                            defaultVal={new Date(ig?.creationDate)?.toLocaleDateString()}
                                            register={registerInvoiceGroups}
                                            style={elementStyle}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{  width: '8.5%' }}>
                                        <RHFInputBox
                                            readOnly={true}
                                            name={`invoiceGroups[${index}].createdBy`}
                                            defaultVal={ig?.createdByName?.toString()}
                                            style={elementStyle}
                                            register={registerInvoiceGroups}
                                        />
                                    </td>
                                    <td style={{ width: '3.5%' }}>
                                        <RHFInputBox
                                            name={`invoiceGroups[${index}].clientNumber`}
                                            readOnly={true}
                                            type="text"
                                            defaultVal={ig?.clientNumber?.toString()}
                                            register={registerInvoiceGroups}
                                            style={elementStyle}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '3.5%' }}>
                                        <RHFInputBox
                                            readOnly={true}
                                            name={`invoiceGroups[${index}].projectNumber`}
                                            type="text"
                                            defaultVal={ig?.projectNumber?.toString()}
                                            register={registerInvoiceGroups}
                                            style={elementStyle}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{  width: '9%' }}>
                                        <RHFInputBox
                                            readOnly={true}
                                            name={`invoiceGroups[${index}].groupAccountCode`}
                                            defaultVal={ig?.groupAccountCode}
                                            style={elementStyle}
                                            register={registerInvoiceGroups}
                                        />
                                    </td>
                                    <td style={{ width: '5%' }}>
                                        <RHFInputBox
                                            readOnly={true}
                                            name={`invoiceGroups[${index}].groupTotal`}
                                            defaultVal={formatForCurrency(ig?.groupTotal?.toString())}
                                            style={totalElementStyle}
                                            register={registerInvoiceGroups}
                                        />
                                    </td>
                                    <td style={{ width: '3%' }}>
                                        <RHFInputBox
                                            readOnly={true}
                                            name={`invoiceGroups[${index}].office`}
                                            defaultVal={ig?.office}
                                            style={elementStyle}
                                            register={registerInvoiceGroups}
                                        />
                                    </td>
                                    <td style={{ width: '2%' }}>
                                        <RHFInputBox
                                            readOnly={true}
                                            name={`invoiceGroups[${index}].count`}
                                            defaultVal={ig?.count?.toString()}
                                            style={elementStyle}
                                            register={registerInvoiceGroups}
                                        />
                                    </td>
                                    <td style={{ width: '5%' }}>
                                        <RHFInputBox
                                            readOnly={true}
                                            name={`invoiceGroups[${index}].sections`}
                                            defaultVal={ig?.sections?.toString()}
                                            style={elementStyle}
                                            register={registerInvoiceGroups}
                                        />
                                    </td>
                                    <td style={{ width: '6%' }}>
                                        <RHFInputBox
                                            readOnly={true}
                                            name={`invoiceGroups[${index}].requestDate`}
                                            defaultVal={ig?.requestDate ? new Date(ig?.requestDate)?.toLocaleDateString() : ''}
                                            register={registerInvoiceGroups}
                                            style={elementStyle}
                                        />
                                    </td>
                                    <td style={{ width: '6%' }}>
                                        <RHFInputBox
                                            readOnly={true}
                                            name={`invoiceGroups[${index}].closeDate`}
                                            register={registerInvoiceGroups}
                                            defaultVal={ig?.closeDate ? new Date(ig?.closeDate)?.toLocaleDateString() : ''}
                                            style={elementStyle}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '8%' }}>
                                        <RHFInputBox
                                            readOnly={true}
                                            name={`invoiceGroups[${index}].closedBy`}
                                            defaultVal={ig?.closedByName ? ig?.closedByName.toString() : ''}
                                            register={registerInvoiceGroups}
                                            style={elementStyle}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '2%' }}>
                                        <RHFInputBox
                                            readOnly={true}
                                            name={`invoiceGroups[${index}].frequency`}
                                            register={registerInvoiceGroups}
                                            defaultVal={ig?.frequency}
                                            style={elementStyle}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '20%' }}>
                                        <div className={'inner-button-container'} style={{display: 'flex', justifyContent: 'flex-start', whiteSpace: 'nowrap'}}>
                                            <Button
                                                style={{paddingLeft: '2px', transform: 'translateY(-.5rem)', height: '3rem', background: 'transparent'}}
                                                text={''}
                                                title="Edit/View Invoice Group"
                                                reactIcon={FiEdit}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => {
                                                    setSelectedInvoiceGroupIndex(index);
                                                    props.setInvoiceGroup?.(ig);
                                                    props.showDialog(DialogList.EDIT_INVOICE_GROUP);
                                                }}
                                                disabled={ig?.closeDate !== null}
                                            />
                                            <Button
                                                style={{paddingLeft: 0, transform: 'translateY(-.5rem)', height: '3rem', marginLeft: '.5rem', background: 'transparent'}}
                                                text={''}
                                                title="Request Invoice Group Closure"
                                                reactIcon={FaHandPaper}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => handleClosureOrCancellationRequest(ig.groupNumber, false, false)}
                                                disabled={!props?.handleClosureRequest ||
                                                    ig?.closeDate !== null ||
                                                    (ig?.closeDate == null && ig?.requestDate != null)}
                                            />
                                            <Button
                                                style={{paddingLeft: 0, transform: 'translateY(-.5rem)', height: '3rem', marginLeft: '.5rem', background: 'transparent'}}
                                                text={''}
                                                title="Cancel Closure Request"
                                                reactIcon={MdCancel}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => handleClosureOrCancellationRequest(ig.groupNumber, true, false)}
                                                disabled={!props?.handleClosureRequest ||
                                                    ig?.closeDate !== null ||
                                                    (ig?.requestDate == null && ig.closeDate == null)}
                                            />
                                            <Button
                                                style={{paddingLeft: 0, transform: 'translateY(-.5rem)', height: '3rem', marginLeft: '.5rem', background: 'transparent'}}
                                                text={''}
                                                title="Close Invoice Group"
                                                reactIcon={ig?.closeDate !== null &&
                                                    ig?.closeDate !== undefined ? FaLock : FaCheckCircle}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => handleClosureOrCancellationRequest(ig.groupNumber, false, true)}
                                                disabled={!props?.handleClosureRequest || shouldDisableClose(ig?.requestDate, ig?.closeDate)}
                                            />
                                            <Button
                                                style={{paddingLeft: 0, transform: 'translateY(-.5rem)', height: '3rem', marginLeft: '.5rem', background: 'transparent'}}
                                                text={''}
                                                title="Add Subcodes"
                                                reactIcon={BiAddToQueue}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2.5rem', height: '2.5rem', verticalAlign: 'center'}}
                                                onClick={() => handleAddSections(index)}
                                                disabled={ig?.closeDate !== null}
                                            />
                                            <Button
                                                style={{paddingLeft: 0, transform: 'translateY(-.5rem)', height: '3rem', marginLeft: '.5rem', background: 'transparent'}}
                                                text={''}
                                                title="Generate Documents"
                                                reactIcon={FaBolt}
                                                iconHoverColor="blue"
                                                iconStyle={{fill: 'yellow', width: '2rem', height: '2.5rem', verticalAlign: 'center'}}
                                                onClick={() => {
                                                    setSelectedInvoiceGroupIndex(index);
                                                    props.setInvoiceGroup?.(ig);
                                                    props?.confirmDocumentGeneration ?
                                                        props.confirmDocumentGeneration() : alert('Implement invoice Group document generation');
                                                }}
                                            />
                                            <Button
                                                style={{paddingLeft: 0, transform: 'translateY(-.5rem)', height: '3rem', marginLeft: '.5rem', background: 'transparent'}}
                                                text={''}
                                                title="Manage Documents"
                                                reactIcon={FaCogs}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => handleViewDocumentMaintenance()}
                                            />
                                            <Button
                                                style={{paddingLeft: 0, transform: 'translateY(-.5rem)', height: '3rem', marginLeft: '.5rem', background: 'transparent'}}
                                                text={''}
                                                title={'Create Excel Spreadsheet'}
                                                reactIcon={SiMicrosoftexcel}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => alert('Implement IG to Excel')}
                                            />
                                            <Button
                                                style={{paddingLeft: 0, transform: 'translateY(-.5rem)', height: '3rem', marginLeft: '.5rem', background: 'transparent'}}
                                                text={''}
                                                title={'Create SupplierLink CSV'}
                                                reactIcon={FaFileCsv}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => handleGetSupplierLinkCsv(ig?.groupNumber ? ig.groupNumber.toString() : '')}
                                            />
                                            <Button
                                                style={{paddingLeft: 0, transform: 'translateY(-.5rem)', height: '3rem', marginLeft: '.5rem', background: 'transparent'}}
                                                text={''}
                                                title="Edit Cover Letter"
                                                reactIcon={FaPenSquare}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => handleEditCoverLetter(ig.groupNumber)}
                                                disabled={loadingInvoices || ig?.closeDate !== null}
                                            />
                                        </div>
                                    </td>
                                </tr>
                        );
                    })}
                </tbody>
            </table>;
    };

    const displayInvoices = () => {
        return  <table style={{textAlign: 'left'}}>
                <thead>
                    <tr>
                        <th>Invoice #</th>
                        <th>Invoice Date</th>
                        <th>SC#</th>
                        <th>Total</th>
                        <th title={'Accounts Receivable'}>A/R</th>
                        <th>Vo</th>
                        <th title={'Descriptions'}>Description</th>
                        <th>District/Township</th>
                        <th>Tract</th>                        
                        <th>IG Account</th>
                    </tr>
                </thead>
                <tbody style={{width: '100%', maxHeight: '30vh', overflowY: 'scroll'}}>
                {invoiceGroupInvoices && invoiceGroupInvoices?.length > 0 && invoiceGroupInvoices?.map(
                    (igs: TsdiInvoiceGroup, index: number) => {
                    const elementStyle = (selectedInvoiceIndex || selectedInvoiceIndex === 0) && selectedInvoiceIndex === index ?
                        {backgroundColor: '#FFFF77', width: '100%', fontSize: '12px'} : {fontSize: '12px', width: '100%'};
                    return (
                            <tr
                                key={index}
                                tabIndex={0}
                                id={'billingApprovalRow' + index}
                                className="table-item-hover"
                                style={{ textAlign: 'center' }}
                                onClick={() => setSelectedInvoiceIndex(index)}
                            >
                                <td style={{ width: '4%' }}>
                                    <RHFInputBox
                                        name={`invoices[${index}].number`}
                                        readOnly={true}
                                        type="text"
                                        defaultVal={igs?.invoiceNumber?.toString()}
                                        register={registerInvoiceGroups}
                                        style={elementStyle}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '6%' }}>
                                    <RHFInputBox
                                        name={`invoices[${index}].date`}
                                        readOnly={true}
                                        type="text"
                                        defaultVal={new Date(igs?.invoiceDate)?.toLocaleDateString()}
                                        register={registerInvoiceGroups}
                                        style={elementStyle}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '4%' }}>
                                    <RHFInputBox
                                        name={`invoices[${index}].section`}
                                        readOnly={true}
                                        type="text"
                                        defaultVal={igs?.sectionNumber?.toString()}
                                        register={registerInvoiceGroups}
                                        style={elementStyle}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '6%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`invoices[${index}].total`}
                                        type="text"
                                        defaultVal={formatForCurrency(igs?.total?.toString())}
                                        register={registerInvoiceGroups}
                                        style={elementStyle}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{  width: '3%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`invoices[${index}].accountsReceivable`}
                                        defaultVal={igs?.posted ? 'Y' : 'N'}
                                        style={elementStyle}
                                        register={registerInvoiceGroups}
                                    />
                                </td>
                                <td style={{ width: '3%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`invoices[${index}].total`}
                                        defaultVal={igs?.voucher ? 'Y' : 'N'}
                                        style={elementStyle}
                                        bodyStyle={{ width: '100%' }}
                                        register={registerInvoiceGroups}
                                    />
                                </td>
                                <td style={{ width: '8%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`invoices[${index}].description`}
                                        defaultVal={igs?.description}
                                        style={elementStyle}
                                        register={registerInvoiceGroups}
                                    />
                                </td>
                                <td style={{ width: '8%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`invoiceGroups[${index}].districtTownship`}
                                        defaultVal={igs?.district}
                                        style={elementStyle}
                                        register={registerInvoiceGroups}
                                    />
                                </td>
                                <td style={{ width: '8%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`invoiceGroups[${index}].tract`}
                                        defaultVal={igs?.tract}
                                        style={elementStyle}
                                        register={registerInvoiceGroups}
                                    />
                                </td>
                                <td style={{ width: '8%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`invoiceGroups[${index}].igAccount`}
                                        defaultVal={igs?.accountCode}
                                        register={registerInvoiceGroups}
                                        style={elementStyle}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>                                
                            </tr>
                    );
                })}
                </tbody>
            </table>;
    };

    return (
        <Dialog title="Invoice Groups" dialogName={props.dialogName} isExitButtonInvisible={false} bodyStyle={{ width: '95vw' }}>
            <div style={{maxHeight: '90vh',  padding: '0px', margin: '0px', overflowY: 'auto'}}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form id={`AltSubcodeMaintenanceForm`} onSubmit={onSubmit}>
                <CollapsibleSection startCollapsed={true} title={`Subcodes`}>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={12}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={displaySectionsSubtitle()}>
                                    <div style={{maxHeight: '40vh', border: 'solid rgb(99, 147, 193) 1px', paddingBottom: '.5rem' }}>
                                    {/*<div style={{marginBottom: '1rem', display: 'flex', alignItems: 'flex-start', gap: '1rem'}}>*/}
                                        {displaySections()}
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                </CollapsibleSection>
                <CollapsibleSection startCollapsed={true} title={`Filters`}>
                <Page className="dlc-maxer-width">
                        <Page.Section width={12}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={displayTitle()}>
                                    <div style={{ whiteSpace: 'nowrap', border: 'solid rgb(99, 147, 193) 1px'}}>
                                        <div className="form-row" style={{ marginBottom: '0' }}>
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Apply filters"
                                                reactIcon={FaPlay}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => handleFilterInvoiceGroups()}
                                            />
                                            <RHFInputBox
                                                label={'Client #'}
                                                name={'clientNumber'}
                                                defaultVal={props?.client?.clientNumber ? props?.client?.clientNumber.toString() : ''}
                                                style={{width: '100%'}}
                                                bodyStyle={{width: '10%'}}
                                                register={registerClientProspect}
                                                readOnly={!props?.subCode}
                                            />
                                            <RHFInputBox
                                                label={'Project #'}
                                                name={'projectNumber'}
                                                style={{width: '100%'}}
                                                bodyStyle={{width: '10%'}}
                                                register={registerClientProspect}
                                                readOnly={!props?.subCode}
                                            />
                                            <RHFSelect
                                                label={'Status'}
                                                defaultVal={1}
                                                name={'groupStatus'}
                                                style={{ width: '100%' }}
                                                bodyStyle={{ width: '10%' }}
                                                options={[
                                                    { value: 1, label: '*' },
                                                    { value: 2, label: 'Open' },
                                                    { value: 3, label: 'Close Requested' },
                                                    { value: 4, label: 'Closed' },
                                                ]}
                                                register={registerClientProspect}
                                                onChange={resetInvoiceGroupSearchOptions}
                                            />
                                            <RHFSelect
                                                style={{ width: '100%' }}
                                                bodyStyle={{ width: '5%' }}
                                                name="billingOffice"
                                                label="Office"
                                                options={[
                                                    { value: 'ALL', label: '*' },
                                                    { value: 'CO', label: 'Denver' },
                                                    { value: 'IH', label: 'In-House' },
                                                    { value: 'MD', label: 'Midland' },
                                                    { value: 'PA', label: 'Pennsylvania' },
                                                    { value: 'OK', label: 'Oklahoma City' },
                                                    { value: 'TX', label: 'Texas' },
                                                    { value: 'RN', label: 'Renewables' },
                                                ]}
                                                register={registerClientProspect}
                                                onChange={resetInvoiceGroupSearchOptions}
                                            />
                                            <RHFSelect
                                                style={{ width: '100%' }}
                                                defaultVal={1}
                                                bodyStyle={{ width: '20%' }}
                                                name="sortBy"
                                                label="Sort by"
                                                options={[
                                                    { value: 1, label: 'Group #' },
                                                    { value: 2, label: 'Request Date' },
                                                    { value: 3, label: 'Client #' },
                                                    { value: 4, label: 'Inovice Group Account' },
                                                    { value: 5, label: 'Created by' },
                                                    { value: 6, label: 'Office' },
                                                    { value: 7, label: 'Close Date' },
                                                    { value: 8, label: 'Closed By' }
                                                ]}
                                                register={registerClientProspect}
                                                onChange={resetInvoiceGroupSearchOptions}
                                            />
                                            <RHFInputBox
                                                label={'Group #'}
                                                name={'groupNumber'}
                                                style={{width: '100%'}}
                                                bodyStyle={{width: '10%'}}
                                                register={registerClientProspect}
                                            />
                                            <RHFSelect
                                                style={{ width: '100%' }}
                                                bodyStyle={{ width: '15%' }}
                                                name="sortDirection"
                                                label="Sort Order"
                                                options={[
                                                    { value: '1', label: 'Descending' },
                                                    { value: '2', label: 'Ascending' }
                                                ]}
                                                register={registerClientProspect}
                                                onChange={resetInvoiceGroupSearchOptions}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Dump to Excel"
                                                reactIcon={SiMicrosoftexcel}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => alert('Implement dump to Excel')}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Excel Summary"
                                                reactIcon={FaFileExcel}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => alert('Implement dump to Excel')}
                                            />
                                            <Button
                                                style={{transform: 'translateY(-.5rem)', height: '3rem', marginLeft: '.5rem', background: 'transparent'}}
                                                text={''}
                                                title="Create New Group"
                                                reactIcon={BiAddToQueue}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2.5rem', height: '2.5rem', verticalAlign: 'center'}}
                                                onClick={() => handleCreateInvoiceGroup()}
                                                disabled={!props?.setCreatingInvoiceGroup}
                                            />
                                        </div>
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                    </CollapsibleSection>
                    <CollapsibleSection title={`Invoice Groups`}>
                        <Page className="dlc-maxer-width">
                            <Page.Section width={12}>
                                <Panel backgroundColor="#D3D3D3">
                                    <Panel panelTitle={displaySubTitle()}>
                                        <div style={{marginBottom: '1rem', display: 'flex', width: '100%', justifyContent: 'center'}}>
                                            {displaySubcodeSettingButtons()}
                                        </div>
                                        <div style={{maxHeight: '40vh', border: 'solid rgb(99, 147, 193) 1px', paddingBottom: '.5rem' }}>
                                            {displayInvoiceGroups()}
                                        </div>
                                    </Panel>
                                </Panel>
                            </Page.Section>
                        </Page>
                    </CollapsibleSection>
                    <CollapsibleSection title={`Invoices`}>
                        <Page className="dlc-maxer-width">
                            <Page.Section width={12}>
                                <Panel backgroundColor="#D3D3D3">
                                    <Panel panelTitle={'invoices'}>
                                        <div style={{display: 'flex', width: '100%', justifyContent: 'left'}}>
                                            <form>
                                                {loadingInvoices && (
                                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                        <span>Loading Invoices...</span>
                                                        <LoadingSpinner />
                                                    </div>
                                                )}
                                                {!loadingInvoices && displayInvoices()}
                                            </form>
                                        </div>
                                    </Panel>
                                </Panel>
                            </Page.Section>
                        </Page>
                    </CollapsibleSection>

                </form>
            </div>
        </div>
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
            <div style={{alignItems: 'center', lineHeight: '1px'}}>
                <label
                    htmlFor={'aggregateTotal'}
                >
                    Total:
                </label>
                <input
                    readOnly={true}
                    defaultValue={''}
                    ref={totalElementRef}
                    name={'aggregateTotal'}
                    style={{border: '0', borderBottom: 'solid gray 1px', marginLeft: '.5rem', height: '25px', width: '100px', background: totalMismatch ? '#CC3333' : '#7CFC00'}}
                />
            </div>
            <div style={{marginLeft: '1rem', whiteSpace: 'nowrap', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{height: '25px', width: '55px', marginRight: '1rem' }}
                    text={'Close'}
                    onClick={() => onCancel()}
                />
            </div>
        </div>
        </Dialog>
    );
};

export default InvoiceGroupingDialog;



// WEBPACK FOOTER //
// ./src/components/client-project/dialogs/InvoiceGroupingDialog.tsx